<template>
  <div class="container pb-40 relative">
    <RecalculationAlert v-if="displayRecalculationAlert"/>
    <InvestmentsModals/>
    <transition name="router-anim">
      <router-view v-if="!current_portfolio.dirty && !!portfolios_list.data.length"/>
    </transition>
    <StartInvesting v-if="!portfolios_list.data.length && !portfolios_list.dirty"/>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import StartInvesting from "@/components/cabinet/Investments/StartInvesting";
import RecalculationAlert from "@/components/cabinet/Investments/RecalculationAlert";
import InvestmentsModals from "@/components/cabinet/Investments/InvestmentsModals";

export default {
  name: "TheInvestments",
  components: {
    StartInvesting,
    InvestmentsModals,
    RecalculationAlert,
  },
  data() {
    return {
      recalculationLongPollRequest: null
    }
  },
  computed: {
    ...mapState('investments/portfolios', ['portfolios_list', 'current_portfolio']),
    ...mapState('space', ['current_space']),
    displayRecalculationAlert() {
      return this.current_portfolio.data === null
          ? false
          : !this.current_portfolio.dirty && this.current_portfolio.data.recalculation
    }
  },
  methods: {
    ...mapActions('investments/portfolios', ['getPortfolios']),
    ...mapMutations('investments/portfolios', ['setActivePortfolio']),
    fetchPortfolioAssets(val) {
      this.$store.dispatch('investments/assets/getAssets', val.id)
      this.$store.dispatch('investments/assets/getGroupedAssets', val.id)
    },
    chooseCurrentPortfolio() {
      let isPortfoliosListEmpty = !this.portfolios_list.data.length,
          lastActivePortfolioID = this.$cookies.get('active_invest_portfolio'),
          lastActivePortfolio = this.portfolios_list.data.find(item => item.id === +lastActivePortfolioID),
          suggestedPortfolio = lastActivePortfolio || this.portfolios_list.data[0];

      if (!isPortfoliosListEmpty) {
        this.setActivePortfolio(suggestedPortfolio);
      }
    },
    async fetchPortfolios() {
      await this.getPortfolios();
      this.chooseCurrentPortfolio();
    },
    async longPollPortfolioRecalculation() {
      let {id} = this.current_portfolio.data,
          url = `/api/invest-portfolios/recalculation/${id}?state=${+!this.current_portfolio.data.recalculation}`
      try {
        let res = await this.$http.get(url, {
          before(request) {
            if (this.previousRequest) {
              this.previousRequest.abort();
            }
            this.previousRequest = request;
            this.recalculationLongPollRequest = this.previousRequest;
          }
        });

        if (res.status === 502) {
          // if timeout subscribe again
          await this.longPollPortfolioRecalculation();
        } else if (res.status !== 200) {
          // error
          console.error(res.statusText);
          // reconnect after 1 sec
          await new Promise(resolve => setTimeout(resolve, 1000));
          await this.longPollPortfolioRecalculation();
        } else {
          // replace with new portfolio state
          try {
            const res = await this.$store.dispatch('investments/portfolios/getPortfolio', id)
            this.$store.commit('investments/portfolios/setActivePortfolio', res.data.data.portfolio)
          } catch (e) {
            console.error(e)
          }
        }
      } catch (e) {
        console.error(e)
      }

    },
    clearLongPollPortfolioRecalculation() {
      if (!!this.recalculationLongPollRequest) {
        this.recalculationLongPollRequest.abort();
      }
    }
  },
  watch: {
    'current_portfolio.data': {
      async handler(current_portfolio) {
        if (!!current_portfolio) {
          this.fetchPortfolioAssets(current_portfolio)
          await this.longPollPortfolioRecalculation();
        }
      }
    },
    'current_space.dirty': {
      immediate: true,
      async handler(val) {
        if (!val) {
          await this.fetchPortfolios();
        }
      }
    }
  },
  created() {
    window.addEventListener('beforeunload', this.clearLongPollPortfolioRecalculation)
  },
  async mounted() {
    if (!this.$store.state.space.accounts.accounts.data.length) {
      this.$store.dispatch('space/accounts/getAccounts');
      this.$store.dispatch('space/accounts/getAccountGroups');
    }
  },
  beforeDestroy() {
    this.clearLongPollPortfolioRecalculation()
    window.removeEventListener('beforeunload', this.clearLongPollPortfolioRecalculation)
  }
}
</script>